<template>
  <button class="guard-feature-card" @click="$emit('click')">
    <div class="guard-feature-card__visual">
      <img class="guard-feature-card__img" :src="logo" :alt="name" />
    </div>
    <div class="guard-feature-card__footer">
      <div class="guard-feature-card__label">{{ name }}</div>
    </div>
  </button>
</template>

<script>
export default {
  name: "CompanyFeatureCard",
  props: {
    name: {
      type: String,
      required: true,
    },
    logo: {
      type: String,
      required: true,
    },
  },
};
</script>

<style scoped lang="scss">
@import '../styles';

.guard-feature-card {
  @include guard-tile;

  &__visual {
    flex: 1;
    background: $guard-white;
    @include guard-flex-center;
    position: relative;
    min-height: 0;
  }
  &__img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    box-sizing: border-box;
    padding: 1rem;
  }
  &__footer {
    background: $guard-navy-900;
    padding: 0.4rem 0.7rem;
    flex-shrink: 0;
    height: 3.7rem;
    @include guard-flex-center;
    text-align: center;
    overflow: hidden;
  }
  &__label {
    font-weight: 600;
    font-size: 0.98rem;
    color: #fff;
    line-height: 1.25;
    text-align: center;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
}
</style>